<template>
    <v-btn
        class="tw-normal-case tw-tracking-normal sm:tw-text-base"
        v-bind="_props">
        <slot></slot>
    </v-btn>
</template>

<script setup lang="ts">
    // use the props of the v-btn component
    import _ from 'lodash';
    import { VBtn } from 'vuetify/components';
    import type { GetValue } from '../components';

    type IoBtn = /* @vue-ignore */ GetValue<VBtn, '$props'>;

    const props = defineProps<IoBtn>();

    const _props = computed(() => {
        const clone = _.cloneDeep(toRaw(props)) as IoBtn;

        if (!clone.color) {
            clone.color = 'primary';
        }
        if (!clone.rounded) {
            clone.rounded = 'pill';
        }

        if (!clone.variant) {
            clone.variant = 'flat';
        }

        return clone;
    });
</script>

<style scoped></style>
